export default __webpack_public_path__ + "static/media/LiveViewIcon.b07bf917.svg";